import React from 'react';
import { cn } from '../../design-system/cn';
import { semanticColors, domainColors, radii, shadows, spacing } from '../../design-system/tokens';
import { glassSurfaces, interactiveCard } from '../../design-system/tokens/surfaces';

const VARIANTS = {
  glass:
    `${semanticColors.surface.glass} ${semanticColors.border.subtle} backdrop-blur-xl ${shadows.glass}`,
  solid:
    `${semanticColors.surface.DEFAULT} ${semanticColors.border.DEFAULT} ${shadows.card}`,
  raised:
    `${semanticColors.surface.raised} ${semanticColors.border.DEFAULT}`,
  subtle:
    `bg-black/30 ${semanticColors.border.DEFAULT}`,
  wallet:
    `${semanticColors.surface.inset} ${domainColors.wallet.border}`,
  danger:
    `bg-gray-900 ${semanticColors.danger.border}`,
  alert:
    `${semanticColors.surface.subtle} ${semanticColors.border.subtle}`,
  admin:
    `bg-violet-500/[0.04] border-violet-500/25`,
  premiumGlass:
    `${glassSurfaces.elevated} ${shadows.premiumGlass}`,
  interactive:
    `${interactiveCard.base} ${shadows.elevation.interactive} ${interactiveCard.hover}`,
};

const PADDING = {
  none: '',
  sm: spacing.card.sm,
  md: spacing.card.md,
  lg: spacing.card.lg,
};

export default function Card({
  variant = 'solid',
  padding = 'md',
  rounded = '2xl',
  className,
  children,
  as: Tag = 'div',
  ...props
}) {
  const radius =
    rounded === '3xl' ? radii.cardLg : rounded === 'pill' ? radii.pill : radii.card;

  return (
    <Tag
      className={cn(
        'border',
        radius,
        VARIANTS[variant] || VARIANTS.solid,
        PADDING[padding] ?? padding,
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}
